import { Controller } from "stimulus";
import Cookies from "js-cookie";

const IS_DARK = "is_dark";

export default class extends Controller {
  lightMode() {
    this._setDarkMode(false);
  }

  darkMode() {
    this._setDarkMode(true);
  }

  _setDarkMode(isDark) {
    Cookies.set(IS_DARK, String(isDark)); // 'true' or 'false'

    if (isDark) {
      // Add .darktheme to body
      document.body.classList.add("darktheme");
    } else {
      document.body.classList.remove("darktheme");
    }
  }

  toggle() {
    const isDark = Cookies.get(IS_DARK) === "true";
    this._setDarkMode(!isDark);
  }
}



// WEBPACK FOOTER //
// ./app/assets/webpack/controllers/dark_controller.js